import React, { useState } from 'react';
import { Control, Controller, FieldError } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { applyInputRules, cn } from '@/utils';
import { Icons } from '@/utils/icons';

interface CustomInputProps {
  name: string;
  control: Control<any>;
  label?: string;
  type?: string;
  placeholder?: string;
  className?: string;
  labelClassName?: string;
  inputClassName?: string;
  error?: FieldError;
  inputRules?: {
    onlyNumber?: boolean;
    onlyAlphabet?: boolean;
    noSpace?: boolean;
    maxLength?: number;
    minLength?: number;
    pattern?: RegExp;
  };
  [key: string]: any;
}

const CustomInput: React.FC<CustomInputProps> = ({
  name,
  control,
  label,
  type = 'text',
  placeholder,
  className = '',
  labelClassName = '',
  inputClassName = '',
  inputRules,
  //   error,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const isPassword = type === 'password';
  const inputType = isPassword ? (showPassword ? 'text' : 'password') : type;

  return (
    <div className={`space-y-2 ${className}`}>
      {label && (
        <label htmlFor={name} className={cn('text-sm', labelClassName)}>
          {label}
        </label>
      )}

      <div>
        <Controller
          name={name}
          control={control}
          defaultValue={''}
          render={({ field, fieldState: { error } }) => (
            <>
              <div className="relative">
                <Input
                  id={name}
                  type={inputType}
                  placeholder={placeholder}
                  {...field}
                  {...props}
                  onChange={(e) => {
                    const sanitizedValue = applyInputRules(e.target.value, inputRules);
                    field.onChange(sanitizedValue);
                  }}
                  className={`!h-[38px] text-black border-gray-800 ${error ? 'border-destructive' : ''} ${
                    isPassword ? 'pr-10' : ''
                  } ${inputClassName}`}
                />
                {/* Password eye toggle */}
                {isPassword && (
                  <Button
                    type="button"
                    variant="ghost"
                    size="sm"
                    className="absolute right-0 top-0 h-full px-3 py-2 "
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <Icons.openEye className="!h-5 !w-5 text-black" />
                    ) : (
                      <Icons.closeEye className="!h-5 !w-5 text-black" />
                    )}
                  </Button>
                )}
              </div>
              {error && <p className="text-sm text-destructive mt-1">{error.message}</p>}
            </>
          )}
        />
      </div>
    </div>
  );
};

export default CustomInput;
